import React from 'react';
import OktaWidgetWrapper from '../../components/OktaWidget/okta-widget-wrapper';

function ResetPassword() {
  return <OktaWidgetWrapper />;
}

export default ResetPassword;
